import { gsap } from 'gsap';

const heroSelector = '.hero';
let ctaSelector;
const heroFullWidthSelector = '.page-template-page-hero-full-width';
const hero = document.querySelector(heroSelector);
const heroFullWidth = document.querySelector(heroFullWidthSelector);

if (heroFullWidth) {
  ctaSelector = '.floating-cta-wrapper.desktop .floating-cta';
} else {
  ctaSelector = '.floating-cta-wrapper .floating-cta';
}

/**
 * Create a debounced scroll handler
 * @param {Function} callback function to call on scroll
 * @returns {Void}
 */
const scrollStop = callback => {
  // Make sure a valid callback was provided
  if (!callback || typeof callback !== 'function') return;

  // Setup scrolling variable
  let isScrolling = false;

  const scrollHandler = () => {
    if (window.innerWidth <= 767) {
      gsap.to(ctaSelector, {
        ease: 'power2.out',
        duration: 0,
        y: 0,
      });

      return;
    }

    // Clear our timeout throughout the scroll
    window.clearTimeout(isScrolling);

    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(callback, 20);
  };

  // Listen for scroll events
  window.addEventListener('scroll', scrollHandler, false);
};

let heroHeight;
let footerOffset;

if (hero && heroFullWidth) {
  heroHeight = hero.getBoundingClientRect().height;
  footerOffset = document.querySelector('footer').getBoundingClientRect().y;
}
let scrollYOffset;
let previousYOffset = 0;
let currentYOffset = 0;

const triggerGsapAnimation = () => {
  gsap.to(ctaSelector, {
    ease: 'power2.out',
    duration: 0.6,
    y: scrollYOffset,
  });
};

const handleScrollUp = () => {
  scrollYOffset = window.pageYOffset - heroHeight;
  triggerGsapAnimation();
};

const handleScrollDown = () => {
  scrollYOffset = window.pageYOffset - heroHeight;
  triggerGsapAnimation();
};

scrollStop(() => {
  const scrollingDisabled = document.querySelector('body').classList.contains('u--no-scroll');

  if (scrollingDisabled) {
    return;
  }

  // if theres no hero on the page return to normal calculations
  if (!hero || !heroFullWidth) {
    scrollYOffset = window.pageYOffset;
    gsap.to(ctaSelector, {
      ease: 'power2.out',
      duration: 0.6,
      y: scrollYOffset,
    });
    return;
  }

  // we're in/above the hero. reset the CTA's position
  if (window.pageYOffset <= heroHeight) {
    scrollYOffset = 0;
    triggerGsapAnimation();
    return;
  }

  // we're in/below the footer. prevent the CTA moving further down
  if (window.pageYOffset >= footerOffset) {
    scrollYOffset = window.pageYOffset - heroHeight;
    triggerGsapAnimation();
    return;
  }

  // calculate scroll depth

  currentYOffset = window.pageYOffset;

  if (previousYOffset > currentYOffset) {
    handleScrollUp();
  } else if (previousYOffset < currentYOffset) {
    handleScrollDown();
  }

  previousYOffset = currentYOffset;
});
